import React, { useState } from 'react';
import { GridSelectionModel } from '@mui/x-data-grid-pro';
import { UseOfForceUploadedFile } from '../../../../api-service/clients';
import {
  FileUploadModal,
  FileUploadResult,
} from '../../../../components/file-upload-modal';
import { AttachmentTable } from '../../common/journal/components/attachments/table/attachment-table';

export interface UseOfForceAttachment {
  id: string;
  fileName: string;
  size: number;
}

interface UseOfForceAttachmentTableProps {
  attachments: UseOfForceAttachment[];
  readOnly?: boolean;
  isLoading?: boolean;
  onAttach: (files: UseOfForceUploadedFile[]) => void;
  onRemove: (attachmentIds: string[]) => void;
  onOpen: (attachmentId: string) => void;
}

// Fasit's standard bilag table and upload dialog; the module keeps the files, so they open through the BFF.
export function UseOfForceAttachmentTable(
  props: UseOfForceAttachmentTableProps
) {
  const {
    attachments,
    readOnly,
    isLoading = false,
    onAttach,
    onRemove,
    onOpen,
  } = props;
  const [isUploadOpen, setIsUploadOpen] = useState(false);

  function handleUploadComplete(results: FileUploadResult[]) {
    setIsUploadOpen(false);
    onAttach(results.map(toUploadedFile));
  }

  return (
    <>
      <AttachmentTable
        attachments={attachments.map(attachment => ({
          id: attachment.id,
          title: attachment.fileName,
          fileName: attachment.fileName,
          fileSize: attachment.size,
        }))}
        onlyShowAttachFileMenu
        attachFile={() => setIsUploadOpen(true)}
        openAttachment={onOpen}
        downloadAttachment={onOpen}
        removeAttachments={(selection: GridSelectionModel) =>
          onRemove(selection.map(String))
        }
        isLoading={isLoading}
        readOnly={readOnly}
      />
      <FileUploadModal
        open={isUploadOpen}
        convertToPdf
        onClose={() => setIsUploadOpen(false)}
        onUploadComplete={handleUploadComplete}
      />
    </>
  );
}

function toUploadedFile(result: FileUploadResult): UseOfForceUploadedFile {
  return {
    documentReference: result.blobReference,
    owner: result.owner,
    fileName: result.fileName,
    contentType: result.mimeType,
  };
}
